export default __webpack_public_path__ + "static/media/flower_image.4fc475b4.png";